import React, { useEffect, useState } from 'react';

import AccordionItem from './AccordionItem';

interface Props {
  /**
   * Id to be applied to the wrapper
   */
  id?: string;
  /**
   * key from the map, do not manually set this
   */
  key?: string;
  /**
   * The indicator on the right of the accordion when closed
   */
  delimiter?: string;
  /**
   * The indicator on the right of the accordion when opened
   */
  delimiterClose?: string;
  /**
   * More than one can be open at one time
   */
  multiOpen?: boolean;
  /**
   * The options for each accordion panel { title: 'test', content: 'hello', isOpen: true }
   */
  options?: { isOpen: boolean; title: string; content: any }[];
}

const Accordion = ({ delimiter = '+', delimiterClose = '-', id, multiOpen = true, options = [] }: Props) => {
  const [o, oSetter] = useState(options);

  useEffect(() => {
    oSetter(options);
  }, [options]);

  const togglePanels = (i: number): void => {
    let optionsMute = options;

    if (multiOpen !== true) optionsMute.map((a) => (a.isOpen = false)); // set them all closed
    optionsMute[i].isOpen = !optionsMute[i].isOpen; // toggle the clicked one

    oSetter([...optionsMute]);
  };

  return (
    <section data-test="component-accordion" id={id} className="nwc--accordion">
      {o.map((item: { title: string; content: any; isOpen: boolean }, i) => (
        <AccordionItem
          key={item.title}
          delimiter={delimiter}
          delimiterClose={delimiterClose}
          item={{
            content: item.content,
            title: item.title,
            isOpen: item.isOpen,
          }}
          togglePanels={togglePanels}
          i={i}
        />
      ))}
    </section>
  );
};

export default Accordion;
